
import { Options, Vue } from "vue-class-component";

@Options({ name: "Footer" })
export default class extends Vue {}
